import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from 'store/libs/baseQuery'

/**
 * See more detail in Tip section
 * https://redux-toolkit.js.org/rtk-query/api/createApi
 */
export const yayApi = createApi({
  baseQuery: axiosBaseQuery({
    client: 'default',
  }),
  reducerPath: 'yayApi',
  endpoints: () => ({}),
})
